'use client'

import PageWithBanner from '@lyra/web/components/layout/PageWithBanner'
import BorrowSection from '@lyra/web/containers/lend/BorrowSection'
import LendSection from '@lyra/web/containers/lend/LendSection'

export default function BorrowPageHelper() {
  return (
    <PageWithBanner
      bannerTitle="Borrow"
      bannerSubtitle="Borrow USDC against your trading collateral"
    >
      <LendSection isLarge noTopBorder showSubaccountSwitch showConnectPrompt />
      <BorrowSection isLarge />
    </PageWithBanner>
  )
}
